{
  "new_round": "Ny runda",
  "creating_round": "Skapar runda...",
  "golf_round": "Golfrunda",
  "score": "Poäng",
  "holes": "hål",
  "holes_played": "hål spelade",
  "active_status": "Aktiv",
  "completed_status": "Slutförd",
  "abandoned_status": "Övergiven",
  "failed_to_load_rounds": "Misslyckades att ladda rundor",
  "failed_to_create_new_round": "Misslyckades att skapa ny runda",
  "failed_to_load_active_round": "Misslyckades att ladda aktiv runda",
  "round": "Runda",
  "new_round_started": "Ny runda startad!",
  "failed_to_create_round": "Misslyckades att skapa ny runda",
  "round_completed": "Runda slutförd!",
  "failed_to_complete_round": "Misslyckades att slutföra runda",
  "are_you_sure_abandon_round": "Är du säker på att du vill överge denna runda?",
  "round_abandoned": "Runda övergiven",
  "delete_round": "Radera runda",
  "delete_round_confirm_title": "Radera runda",
  "delete_round_confirm_message": "Är du säker på att du vill radera rundan '{{roundName}}'? Denna åtgärd kan inte ångras.",
  "round_deleted_successfully": "Runda raderad",
  "failed_to_delete_round": "Misslyckades att radera runda",
  "delete_not_supported_yet": "Radering stöds ännu inte av servern",
  "failed_to_abandon_round": "Misslyckades att överge runda",
  "abandon": "Överge",
  "abandon_round": "Överge",
  "complete": "Slutför",
  "complete_round": "Slutför",
  "are_you_sure_complete_round": "Är du säker på att du vill slutföra denna runda?",
  "pause": "Pausa",
  "pause_round": "Pausa",
  "are_you_sure_pause_round": "Är du säker på att du vill pausa denna runda? Du kan fortsätta senare.",
  "round_paused": "Runda pausad framgångsrikt!",
  "failed_to_pause_round": "Misslyckades att pausa runda",
  "round_management": "Runda hantering",
  "hole": "Hål",
  "failed_to_update_score": "Misslyckades att uppdatera poäng",
  "failed_to_mark_picked_up": "Misslyckades att markera som upplockad",
  "picked_up": "Upplockad",
  "failed_to_clear_score": "Misslyckades att rensa poäng",
  "scorecard": "Scorekort",
  "current_hole": "Nuvarande hål",
  "out": "Out",
  "in": "In",
  "tot": "Tot",
  "par": "Par",
  "handicap_index": "Handikappindex",
  "playing_handicap": "Spelhandicap",
  "course": "Bana",
  "start_round": "Starta runda",
  "select_course_and_tee": "Välj bana och tee",
  "search_courses": "Sök banor...",
  "select_course": "Välj bana",
  "recent_courses": "Senaste banor",
  "no_courses_found": "Inga banor hittades",
  "no_courses_available": "Inga banor tillgängliga",
  "select_tee_set": "Välj tee",
  "failed_to_load_courses": "Misslyckades att ladda banor",
  "failed_to_load_course_details": "Misslyckades att ladda bandetaljer",
  "scorecard_view": {
    "scorecard_not_found": "Scorekort hittades inte",
    "scorecard_not_found_subtitle": "Det begärda scorekortet kunde inte laddas",
    "scorecard_not_found_message": "Detta scorekort kan ha tagits bort eller så har du inte behörighet att visa det.",
    "back_to_dashboard": "Tillbaka till startsidan",
    "back": "Tillbaka",
    "date_played": "Spelad datum",
    "notes": "Anteckningar",
    "length": "Längd",
    "hcp": "HCP",
    "score": "Poäng",
    "par": "Par",
    "hole": "Hål",
    "golf_course": "Golfbana",
    "no_scorecard_data": "Ingen skortkortdata tillgänglig",
    "failed_to_load_scorecard": "Misslyckades att ladda scorekort",
    "strokes": "Slag",
    "hole_disabled": "Hålet är inte i bruk för denna runda",
    "pituus": "Längd",
    "delete_round": {
      "section_title": "Ta bort runda",
      "button_label": "Ta bort runda",
      "modal_title": "Ta bort runda",
      "modal_body": "Är du säker på att du vill ta bort denna runda? Rundan tas bort permanent från din statistik och åtgärden kan inte ångras.",
      "modal_confirm": "Ta bort runda",
      "modal_cancel": "Avbryt"
    },
    "share": "Dela",
    "share_preview_title": "Dela resultatkort",
    "share_recommended": "Rekommenderat delningssätt",
    "share_variant_feed": "Instagram- och Facebook-flöde",
    "share_variant_story": "Instagram-story",
    "share_title": "Min golfrunda",
    "share_text": "{{course}} — {{score}} ({{date}})",
    "share_failed": "Delning av bild misslyckades"
  },
  "conditions": {
    "optional_conditions": "Förhållanden",
    "weather": "Väder",
    "weather_sunny": "Soligt",
    "weather_cloudy": "Molnigt",
    "weather_light_rain": "Lätt regn",
    "weather_heavy_rain": "Kraftigt regn",
    "weather_light_wind": "Lätt vind",
    "weather_strong_wind": "Stark vind",
    "pin_placement": "Flaggplacering",
    "pin_easy": "Lätt",
    "pin_average": "Medel",
    "pin_hard": "Svår",
    "green_pace": "Greenhastighet",
    "pace_slow": "Långsam",
    "pace_average": "Medel",
    "pace_fast": "Snabb",
    "green_hardness": "Greenhårdhet",
    "hardness_soft": "Mjuk",
    "hardness_average": "Medel",
    "hardness_hard": "Hård",
    "comment": "Ytterligare anteckningar",
    "temperature": "Temperatur",
    "wind_speed": "Vindhastighet",
    "add_conditions": "Lägg till förhållanden",
    "updated_successfully": "Förhållandena uppdaterades",
    "update_failed": "Uppdatering av förhållanden misslyckades",
    "no_comment": "Ingen ytterligare information",
    "set_conditions": "Ställ in",
    "comment_placeholder": "Skriv en kommentar"
  },
  "cr": "CR",
  "slope": "Slope",
  "tee": "Tee",
  "total": "Totalt",
  "net_total": "Nettoresultat",
  "tee_selection": "Tee",
  "handicap": "Handikapp",
  "handicap_abbr": "HCP",
  "quick_hole_nav": "Gå till hål",
  "starting_hole": "Starthål",
  "starting_hole_help": "Välj hål där du börjar rundan",
  "front_nine": "Hål 1-9",
  "back_nine": "Hål 10-18",
  "private_round": "Privat runda",
  "private_round_description": "Rundan syns inte för dina vänner",
  "private": "Privat",
  "distance_unit": "Längdenhet",
  "distance_unit_help": "Välj vilken enhet du anger fairwaylängder i",
  "handicap_factor": "Handikapfaktor",
  "round_completed_and_submitted_to_competitions": "Rundan klar och inskickad till {{count}} veckotävling!",
  "round_completed_but_submission_failed": "Rundan klar, men inskickning till veckotävlingar misslyckades",
  "round_started_with_competitions": "Ny runda startad i veckotävlingen!",
  "start_round_v2": "Starta runda (V2)",
  "course_and_tee": "Bana och tee",
  "played_date": "Spelad",
  "round_actions": {
    "title": "Vill du avsluta rundan?",
    "complete": "Avsluta runda",
    "pause": "Spara och fortsätt senare",
    "delete": "Radera runda",
    "close": "Stäng"
  },
  "hole_status": {
    "completed": "Spelat",
    "current": "Nuvarande",
    "not_played": "Inte spelat",
    "picked_up": "Upplockat"
  },
  "round_result_confirmation": {
    "title": "Bekräfta rundresultat",
    "round_information": "Rundainformation",
    "player_name": "Spelare",
    "exact_handicap": "Handikapp",
    "course_name": "Bana",
    "tee_name": "Tee",
    "course_rating": "CR",
    "slope_rating": "Slope",
    "playing_handicap": "Spelhandikapp",
    "scorecard": "Scorekort",
    "gross_total": "Totalt slag (brutto)",
    "net_total": "Nettoresultat",
    "confirmation_message": "Granska uppgifterna och bekräfta rundresultatet. Efter bekräftelse kan du ange banförhållanden.",
    "accept": "Bekräfta resultat"
  },
  "statistics": {
    "title": "Statistik",
    "track_stats": "Statistik aktiverad",
    "track_stats_description": "Registrera slagstatistik för denna runda",
    "hole_statistics": "Hålstatistik",
    "save": "Spara",
    "tee_shot": "Utslag",
    "fairway": "Fairwayträff",
    "fairway_center": "Mitten",
    "fairway_right": "Höger",
    "fairway_left": "Vänster",
    "fairway_short": "Kort",
    "fairway_long": "Lång",
    "approach": "Inspel",
    "green": "Greenträff",
    "green_hit": "Träff",
    "green_right": "Höger",
    "green_left": "Vänster",
    "green_short": "Kort",
    "green_long": "Lång",
    "short_game": "Kortspel",
    "putts": "Puttar",
    "chips": "Chippar",
    "bunker_shots": "Bunkersslag",
    "penalties": "Pliktslag",
    "putting": "Puttning",
    "first_putt_length": "Första putt",
    "sunk_putt_length": "Sänkt putt",
    "meters": "meter",
    "first_putt_not_set": "Ej inställd",
    "first_putt_under_3m": "Under 3 meter",
    "first_putt_3_5m": "3-5 meter",
    "first_putt_5_10m": "5-10 meter",
    "first_putt_10_20m": "10-20 meter",
    "first_putt_over_20m": "Över 20 meter",
    "saves": "Räddningar",
    "up_and_down": "Up & Down",
    "sand_save": "Sand Save",
    "fairway_hits": "Fairwayträffar",
    "green_hits": "Greenträffar",
    "avg_putts": "Snitt puttar",
    "avg_putt_distance": "Snitt puttavstånd (m)",
    "no_data": "Ingen statistik",
    "stats_saved": "Statistik sparad",
    "stats_deleted": "Statistik raderad",
    "failed_to_save_stats": "Misslyckades att spara statistik",
    "failed_to_delete_stats": "Misslyckades att radera statistik",
    "clear_stats": "Rensa",
    "par3_no_fairway": "Fairwaystatistik samlas inte in för par 3-hål",
    "par3_no_green": "Greenstatistik samlas inte in för par 3-hål",
    "stats_reminder_title": "Statistik saknas",
    "stats_reminder_message": "Du har inte sparat statistik för detta hål. Vill du lägga till dem nu?",
    "add_stats": "Lägg till statistik",
    "skip_stats": "Hoppa över",
    "round_stats": "Rundastatistik",
    "fir": "FIR",
    "gir": "GIR",
    "ppg": "PPG",
    "fairways_caption": "Fairways",
    "greens_caption": "Greener",
    "putts_per_hole": "Puttar per hål",
    "first_putt_avg": "1 putt snitt (m)"
  },
  "handicap_round": {
    "toggle": "Handikapprunda",
    "marker_name": "Markörens namn",
    "info": "Resultatet skickas till eBirdie som en handikapprunda",
    "info_competition": "Resultatet rapporteras till eBirdie som tävlingsrunda",
    "marker_label": "Markerare",
    "marker_required": "Markerarens namn krävs för att skicka resultatet till eBirdie"
  },
  "unit_suffix": {
    "metric": "m",
    "imperial": "y"
  },
  "units": {
    "meters": "Meter",
    "yards": "Yards"
  },
  "hole_scores": "Hålresultat",
  "hcp_badge": "HCP",
  "round_finalize": {
    "save_round": "Spara runda",
    "back_to_scoring": "Återgå till resultatinmatning",
    "handicap_update_failed": "Fel vid sparande av handikapprundan",
    "marker_required_warning": "Ange markörens namn för att föra över rundan till eBirdien"
  },
  "played_date_edit_title": "Rundens tidpunkt",
  "played_date_updated_successfully": "Rundens tidpunkt uppdaterad",
  "played_date_update_failed": "Uppdatering av rundens tidpunkt misslyckades",
  "start_round_pay_required": "Gå till betalning",
  "start_round_pay_voluntary": "Fortsätt",
  "nearest_courses": "Närmaste banor",
  "all_courses": "Alla banor",
  "record_round_title": "Registrera runda",
  "record_round_subtitle": "Fyll i uppgifterna och gå vidare till resultatkortet för att ange resultaten.",
  "desktop_scorecard": {
    "score": "Resultat",
    "net": "Netto",
    "points": "Poäng",
    "total": "Totalt"
  },
  "continue_to_scorecard": "Fortsätt till resultatkortet",
  "multiplayer": {
    "players_title": "Spelare",
    "add_players": "Lägg till spelare",
    "add_players_description": "Håll resultatkort för hela gruppen",
    "tab_ebirdie": "eBirdie",
    "tab_friends": "Vänner",
    "tab_manual": "Annan",
    "search_title": "Sök i eBirdie",
    "search_placeholder": "Namn eller medlemsnummer",
    "search_club": "Klubb",
    "search_button": "Sök spelare",
    "search_results_title": "Sökresultat",
    "search_no_results": "Inga sökresultat",
    "add": "Lägg till",
    "manual_title": "Lägg till manuellt",
    "first_name": "Förnamn",
    "last_name": "Efternamn",
    "handicap": "Handikapp",
    "gender": "Kön",
    "add_player": "Lägg till spelare",
    "settings_title": "Spelarinställningar",
    "name": "Namn",
    "tee": "Tee",
    "save": "Spara",
    "remove_player": "Ta bort spelare",
    "close": "Stäng",
    "next": "Nästa",
    "create_round": "Skapa runda",
    "group_created": "Grupprundan skapad",
    "max_players": "Du kan lägga till högst tre spelare",
    "already_added": "Spelaren är redan tillagd",
    "scr": "SCR",
    "result": "Resultat",
    "host_scores_hint": "Endast rundens värd kan registrera resultat",
    "group_section_title": "Grupprunda",
    "abandon_confirm_title": "Avbryt grupprunda?",
    "abandon_confirm_body": "Rundan avslutas för alla spelare i gruppen och kan inte fortsättas. Detta kan inte ångras.",
    "game": {
      "step_title": "Spelformat",
      "format": {
        "skins": "Skins",
        "stroke_play_abbr": "LP",
        "stableford_abbr": "PB",
        "max_score_abbr": "MAX",
        "best_ball_abbr": "BB",
        "skins_abbr": "S"
      },
      "select": "Välj",
      "selected": "Vald",
      "coming_soon": "Kommer snart",
      "coefficient_label": "Handikappkoefficient",
      "handicap_percent": {
        "scratch": "Scratch",
        "twenty_five": "25 %",
        "fifty": "50 %",
        "seventy_five": "75 %",
        "hundred": "100 %"
      },
      "change_action": "Redigera spelinställningar",
      "change_title": "Byt spel",
      "save": "Spara",
      "cancel": "Avbryt",
      "change_failed": "Det gick inte att byta spel",
      "best_ball_requires_four": "Kräver 4 spelare"
    },
    "teams": {
      "own_team": "Eget lag",
      "choose_partner": "Välj lagkamrat",
      "add_partner": "Välj som partner",
      "remove_partner": "Ta bort partner",
      "team1": "Lag 1",
      "team2": "Lag 2"
    },
    "leaderboard": {
      "thru": "HÅL",
      "gross": "TOT",
      "to_par": "PAR",
      "points": "POÄNG",
      "net": "NET",
      "failed_to_load": "Det gick inte att ladda resultattavlan",
      "team": "Lag {{number}}"
    }
  }
}
